export const GET_TOURNAMENT = "GET_TOURNAMENT";
export const POST_TOURNAMENT = "POST_TOURNAMENT";
export const SHOW_TOURNAMENT = "SHOW_TOURNAMENT";
export const UPDATE_TOURNAMENT = "UPDATE_TOURNAMENT";
export const UPDATE_STATUS_TOURNAMENT = "UPDATE_STATUS_TOURNAMENT";
export const DELETE_TOURNAMENT = "DELETE_TOURNAMENT";
export const GET_MEMBER_GROUP = "GET_MEMBER_GROUP";
export const GET_TYPE = "GET_TYPE";
export const SHOW_WINNERLIST = "SHOW_WINNERLIST";
